module.exports = () =>
  typeof document !== 'undefined' && 'classList' in document.createElement('a');



// WEBPACK FOOTER //
// ./src/js/helpers/hasClassListCapability.js